module.exports = __webpack_public_path__ + "static/media/GipsyLogo.ec62be97.png";